import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=deb067d4&scoped=true&"
var script = {}
import style0 from "./privacy.vue?vue&type=style&index=0&id=deb067d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb067d4",
  null
  
)

export default component.exports